// extracted by mini-css-extract-plugin
module.exports = {"flexWrapper":"MDXMetadata-module--flexWrapper--3iAg4","item":"MDXMetadata-module--item--2i8WN"};